import { ValidationError } from '@goodt-common/domain';
import { MessageI18n } from '@goodt-common/utils';
import { QueryModelValidatorMessages } from '../lang';

export class QueryModelValidator {
    _query;

    constructor(query) {
        this._query = query;
    }

    validateDrilldownConflictNames() {
        const { drilldowns, dimensions, metrics } = this._query;
        const params = [...dimensions, ...metrics];
        const conflictingDrilldownNames = drilldowns
            .filter(({ name }) => params.includes(name))
            .map(({ name }) => name);
        return conflictingDrilldownNames.map(
            (name) => {
                const message = new MessageI18n(QueryModelValidatorMessages.DRILLDOWN_CONFLICTING_QUERY_PARAM, {
                    name
                });
                return new ValidationError(
                    message,
                    {
                        drilldowns: {
                            [name]: {
                                message
                            }
                        }
                    }
                );
            }
        );
    }

    validateDrilldownIncompleteDimensions() {
        const { drilldowns, dimensions } = this._query;
        const incompleteDrilldowns = drilldowns
            .filter(
                ({ dimensions: _dimensions }) =>
                    _dimensions.some((dimension) => !dimensions.includes(dimension))
            );

        return incompleteDrilldowns.map(
            ({ name, dimensions: _dimensions }) => {
                // missed drilldown dimension details
                const missedDimensions = _dimensions.filter((dimension) => !dimensions.includes(dimension));
                const message = new MessageI18n(QueryModelValidatorMessages.DRILLDOWN_MISSED_QUERY_DIMENSIONS, {
                    name,
                    dimensions: missedDimensions.join(', ')
                });
                // missed query dimension details
                const dimensionsDetails = Object.fromEntries(
                    missedDimensions.map((dimension) => {
                        const message = new MessageI18n(QueryModelValidatorMessages.QUERY_DIMENSION_MISSED, {
                            name: dimension
                        });
                        return [dimension, { message }];
                }));

                return new ValidationError(
                    message,
                    {
                        drilldowns: {
                            [name]: {
                                message
                            }
                        },
                        dimensions: dimensionsDetails
                    }
                );
            }
        );
    }

    validateSort() {
        const { sort, dimensions, metrics } = this._query;
        const params = [...dimensions, ...metrics];
        const invalidSort = sort.filter(({ name }) => params.includes(name) === false).map(({ name }) => name);
        return invalidSort.map(
            (name) => {
                const message = new MessageI18n(QueryModelValidatorMessages.SORT_MISSED_QUERY_PARAM, {
                    name
                });
                return new ValidationError(
                    message,
                    {
                        sort: {
                            [name]: {
                                message
                            }
                        }
                    }
                );
            }
        );
    }

    validateFilters() {
        const { filters, dimensions, metrics, fields } = this._query;
        const params = [...dimensions, ...metrics, ...fields];
        const invalidFilters = filters.filter(({ name }) => params.includes(name) === false).map(({ name }) => name);
        return invalidFilters.map(
            (name) => {
                const message = new MessageI18n(QueryModelValidatorMessages.FILTER_MISSED_QUERY_PARAM, {
                    name
                });
                return new ValidationError(
                    message,
                    {
                        filters: {
                            [name]: {
                                message
                            }
                        }
                    }
                );
            }
        );
    }

    validate() {
        return [
            ...this.validateDrilldownConflictNames(),
            ...this.validateDrilldownIncompleteDimensions(),
            ...this.validateSort(),
            ...this.validateFilters()
        ];
    }
}